import React, { useState, useEffect } from "react";
import companyService from "../services/company.service";

function FileList({ id }) {
  const [files, setFiles] = useState([]);

  const loadFiles = async () => {
    const res = await companyService.filesAll({
      companyId: id,
    })
    setFiles(res.data)
  }

  useEffect(() => {
    loadFiles()
  }, [])

  return (
    <div>
      <h1>File List</h1>
    </div>
  )
}

export default FileList;